<div class="dropdown">
  <label for="actions-dropdown"
    >{{ 'COMMON.LABEL.ACTIONS' | translate }}:
  </label>
  <div class="input">
    <p-select
      inputId="actions-dropdown"
      [options]="availableActions()"
      optionLabel="label"
      [(ngModel)]="currentAction"
      placeholder="{{ 'COMMON.LABEL.SELECT_ACTION' | translate }}"
      (onChange)="this.actionSelected.emit($event.value.label)"
      [disabled]="isDisabled"
      scrollHeight="calc(100vh - 35vh)"
    />
  </div>
</div>
